import getInsuranceInsuredsAddress from 'utils/print/getInsuranceInsuredsAddress';
import getInsuranceInsuredsCity from 'utils/print/getInsuranceInsuredsCity';
import getInsuranceInsuredsState from 'utils/print/getInsuranceInsuredsState';
import getInsuranceInsuredsZip from 'utils/print/getInsuranceInsuredsZip';

const getInsuranceInsuredsFullAddress = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const address = getInsuranceInsuredsAddress(otherProps);
  const city = getInsuranceInsuredsCity(otherProps);
  const state = getInsuranceInsuredsState(otherProps);
  const zip = getInsuranceInsuredsZip(otherProps);

  if (address && city && zip) {
    return `${address}, ${city}, ${state || ''} ${zip}`;
  }

  return null;
};

export default getInsuranceInsuredsFullAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsFullAddress.js